import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {HttpCommonService} from '../../../../../shared/services/http-common.service';
import {Observable} from 'rxjs';
import {GenericHttpResponse} from '../../../../../shared/services/interfaces/generic-http-response.interface';
import {Prospecto, ProspectoFiltros, ProspectoPayload} from './prospectos.interface';

@Injectable({
  providedIn: 'root'
})
export class ProspectosService {
  private http = inject(HttpClient);
  private httpCommonService = inject(HttpCommonService);

  index(page: number = 1, perPage: number = 15, filtros?: ProspectoFiltros): Observable<GenericHttpResponse<any>> {
    const url = this.httpCommonService.makeUrl('/crms/prospectos');

    let params = new HttpParams()
      .set('page', page.toString())
      .set('per_page', perPage.toString());

    if (filtros) {
      if (filtros.busqueda?.trim()) {
        params = params.set('busqueda', filtros.busqueda.trim());
      }
      if (filtros.tipo?.trim()) {
        params = params.set('tipo', filtros.tipo.trim());
      }
      if (filtros.es_cliente?.trim()) {
        params = params.set('es_cliente', filtros.es_cliente.trim());
      }
      if (filtros.canal_captacion_id?.trim()) {
        params = params.set('canal_captacion_id', filtros.canal_captacion_id.trim());
      }
    }

    return this.http.get<GenericHttpResponse<any>>(url, { params });
  }

  show(id: number): Observable<GenericHttpResponse<Prospecto>> {
    const url = this.httpCommonService.makeUrl(`/crms/prospectos/${id}`);
    return this.http.get<GenericHttpResponse<Prospecto>>(url);
  }

  store(body: ProspectoPayload): Observable<GenericHttpResponse<Prospecto>> {
    const url = this.httpCommonService.makeUrl('/crms/prospectos');
    return this.http.post<GenericHttpResponse<Prospecto>>(url, body);
  }

  update(id: number, body: ProspectoPayload): Observable<GenericHttpResponse<Prospecto>> {
    const url = this.httpCommonService.makeUrl(`/crms/prospectos/${id}`);
    return this.http.put<GenericHttpResponse<Prospecto>>(url, body);
  }

  destroy(id: number): Observable<GenericHttpResponse<Prospecto>> {
    const url = this.httpCommonService.makeUrl(`/crms/prospectos/${id}`);
    return this.http.delete<GenericHttpResponse<Prospecto>>(url);
  }
}
